// extracted by mini-css-extract-plugin
module.exports = {"header":"header___1SsES","spacer":"spacer___1mIZF","logo":"logo___1zaUn","overlay":"overlay___2D1eR","wrapper":"wrapper___3NfjU"};